export class EntitlementRequest {
  clientId: string;
  serviceId: string;
  groupId: string;
  groupName: string;
  key: string;
  value: string;
  createBy: string;
  oldValue: string;
  description: string;
}

export class Entitlement {
  clientId: string;
  serviceId: string;
  clientName: string;
  serviceName: string;
  groupId: string;
  groupName: string;
  name: string;
  entitlements: EntitlementKey[];
  createBy: string;
  createDate: string;
  description: string;
  key: string;
  value: string;
}

type EntitlementItem = {
  [key: string]: string;
};

export class EntitlementKey {
  group: EntitlementItem;
  data: EntitlementItem;
  description?: EntitlementItem;
}
